const merchant = {
    path: 'merchant/list',
    component: resolve => require(['../../../../../pages/admin/channel/merchant/list'], resolve),
    meta: {
        requireAuth: true
    }
}

export default merchant